import { MenuItemForm } from '@core/models';
import { HomeSingleProductFormRule } from '../interfaces';

export const homeSingleProductFormChannelRule: HomeSingleProductFormRule = context => ({
	...context,
	productChannel: context.article.productosCanal?.[0],
});

export const homeSingleProductSelectedPriceRule: HomeSingleProductFormRule = context => {
	const prices = context.productChannel?.precios;
	const selectedPrice = context.article.precio ?? prices?.[0]?.precio ?? 0n;
	const matchingPriceIndex = prices?.findIndex(price => price.precio === selectedPrice) ?? -1;

	return {
		...context,
		selectedPriceIndex: matchingPriceIndex < 0 ? 0 : matchingPriceIndex,
	};
};

export const homeSingleProductFormValueRule: HomeSingleProductFormRule = context => {
	const { article, productChannel, selectedPriceIndex } = context;
	const formValue: MenuItemForm = {
		idCartItem: article.idCartItem ?? null,
		idArticulo: article.idArticulo,
		cantItemsInCart: article.cantItemsInCart ?? 0,
		suggestItems: article.suggestItems ?? [],
		gruposModificadores:
			article.gruposModificadores?.map(group => ({
				id: group.id,
				posicion: group.posicion,
				moduloDisponibles: group.moduloDisponibles || [],
				grupoModificador: {
					idGrupomodificador: group.grupoModificador.idGrupomodificador,
					nombre: group.grupoModificador.nombre,
					descripcion: group.grupoModificador.descripcion || null,
					minimo: group.grupoModificador.minimo || 0,
					maximo: group.grupoModificador.maximo || 0,
					gratis: group.grupoModificador.gratis || 0,
					usuario: group.grupoModificador.usuario || null,
					mostrarVentanaModificador: group.grupoModificador.mostrarVentanaModificador || false,
					detallesmodificadores: group.grupoModificador.detallesmodificadores?.map(detail => ({
						idDetalleModificador: detail.idDetalleModificador,
						posicionModificador: detail.posicionModificador,
						precio: detail.precio || 0,
						precioBase: detail.precioBase || 0,
						precioInicial: detail.precio || 0,
						grupoModificadorId: detail.grupoModificadorId,
						fechaCreacion: detail.fechaCreacion,
						fechaActualizacion: detail.fechaActualizacion,
						isFree: detail.isFree ?? false,
						addExtra: detail.addExtra ?? false,
						noAdd: detail.noAdd ?? false,
						cantidad: detail.cantidad ?? 0,
						modificador: {
							idModificador: detail.modificador.idModificador,
							nombre: detail.modificador.nombre,
							nombreCocina: detail.modificador.nombreCocina || null,
							nombreRecibo: detail.modificador.nombreRecibo || null,
							color: detail.modificador.color || null,
							usuario: detail.modificador.usuario || null,
						},
						prefijosgrupomodificadores: detail.prefijosgrupomodificadores?.map(prefix => ({
							idPrefijoGrupoModificador: prefix.idPrefijoGrupoModificador,
							precio: prefix.precio || 0,
							precioBase: prefix.precioBase || 0,
							prefijoModificador: {
								idPrefijoModificador: prefix.prefijoModificador.idPrefijoModificador,
								nombre: prefix.prefijoModificador.nombre,
								codigo: prefix.prefijoModificador.codigo || null,
								localId: prefix.prefijoModificador.localId || null,
							},
						})),
					})),
				},
			})) || [],
		nota: article.nota ?? null,
		cantidad: article.cantidad ? Number(article.cantidad) : 1,
		impuestos: article.impuestos,
		selectedPriceIndex: selectedPriceIndex ?? 0,
		precio: article.precio ? article.precio : (productChannel?.precios?.[0]?.precio ?? 0),
		precioBase: article.precioBase ? article.precioBase : (productChannel?.precios?.[0]?.precioBase ?? 0),
		productosCanal: {
			idProducto: productChannel?.idProducto || null,
			descripcion: productChannel?.descripcion || null,
			nombre: productChannel?.nombre || null,
			infoNutricional: productChannel?.infoNutricional || null,
			mostrarInstrucciones: productChannel?.mostrarInstrucciones || false,
			porPeso: productChannel?.porPeso || false,
			habilitado: productChannel?.habilitado || false,
			precioPersonalizado: productChannel?.precioPersonalizado || false,
			nombrePersonalizado: productChannel?.nombrePersonalizado || false,
			precios: productChannel?.precios,
			imagen: productChannel?.imagen || null,
			localCanal: productChannel?.localCanal || null,
			mealSelected: null,
		},
	};

	return { ...context, formValue };
};
